import { z } from 'zod';
import { selfServiceIntakeDescriptionMaxLength } from '@axiom/const';

export const DirectEngagementsFormIntakeSuggestionModalSchema = z.object({
  intakeDescription: z
    .string()
    .max(selfServiceIntakeDescriptionMaxLength)
    .nullable(),
});

export type DirectEngagementsFormIntakeSuggestionModalForm = z.infer<
  typeof DirectEngagementsFormIntakeSuggestionModalSchema
>;
